import React from "react";
import * as FaIcons from "react-icons/fa";

import states from "../../../data/states";

const R7PreviousSchoolInformation = ({
  formData,
  onFormDataChange,
  validationCheck,
}) => {
  const { firstName, previousSchool, previousSchoolCity, previousSchoolState } =
    formData;
  return (
    <>
      {/* Previous School/Enrollment Information */}
      <div className="sub-form">
        <h3>Previous School Information</h3>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              What is {firstName === "" ? "the Student" : firstName}'s Previous
              School?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="previousSchool"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={previousSchool}
            style={{
              border:
                validationCheck && !(previousSchool !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          />
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              What is {firstName === "" ? "the Student" : firstName}'s Previous
              School City?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="previousSchoolCity"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={previousSchoolCity}
            style={{
              border:
                validationCheck && !(previousSchoolCity !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          />
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              What is {firstName === "" ? "the Student" : firstName}'s Previous
              School State?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="previousSchoolState"
            value={previousSchoolState}
            onChange={(e) => onFormDataChange(e)}
            style={{
              border:
                validationCheck && !(previousSchoolState !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <option value="">Please Select</option>
            {states.map((item) => {
              return (
                <option value={Object.keys(item)}>{Object.keys(item)}</option>
              );
            })}
          </select>
        </div>
      </div>
    </>
  );
};

export default R7PreviousSchoolInformation;
